import { render, staticRenderFns } from "./profit_transfer_detail.vue?vue&type=template&id=00ac5401&scoped=true"
import script from "./profit_transfer_detail.vue?vue&type=script&lang=js"
export * from "./profit_transfer_detail.vue?vue&type=script&lang=js"
import style0 from "./profit_transfer_detail.vue?vue&type=style&index=0&id=00ac5401&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac5401",
  null
  
)

export default component.exports